import { render, staticRenderFns } from "./SkillDetailModal.vue?vue&type=template&id=0728c5da&scoped=true&"
import script from "./SkillDetailModal.vue?vue&type=script&lang=js&"
export * from "./SkillDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./SkillDetailModal.vue?vue&type=style&index=0&id=0728c5da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0728c5da",
  null
  
)

export default component.exports